<div [formGroup]="triggerConfigTimeBasedForm">

  <!--GATEWAYS-->
  <div class="form-group">
    <label for="cloudPlug" translate>Gateways for machine</label>
    <scitis-required-field-indicator></scitis-required-field-indicator>
    @if (isLoadingCloudPlugs) {
      <span class="fa-solid fa-spinner fa-spin"></span>
    }
    <ng-select (focusout)="onFocusOut()"
      [disabled]="!isAdminOrHigher" [items]="cloudPlugs"
      [ngClass]="{ 'is-invalid': submitted && formControls.cloudPlug.errors }"
      bindLabel="name" bindValue="id" formControlName="cloudPlug" id="cloudPlug"
      name="cloudPlug" placeholder="Select gateway">
    </ng-select>
    @if (submitted && formControls.cloudPlug.errors) {
      <div class="invalid-feedback">
        <span translate>Gateway selection required</span>
      </div>
    }
  </div>


  <div class="row">
    <div class="col-12 col-lg-6">

      <!--INTERVAL-->
      <div class="form-group">
        <label for="interval" translate>Interval, execute every</label>
        <scitis-required-field-indicator></scitis-required-field-indicator>
        <input (focusout)="onFocusOut()" (input)="onFocusOut()"
          [disabled]="!isAdminOrHigher" [ngClass]="{ 'is-invalid': submitted && formControls.interval.errors }" class="form-control" formControlName="interval" id="interval"
          name="interval"
          type="number">
          @if (submitted && formControls.interval.errors) {
            <div class="invalid-feedback">
              @if (formControls.interval.errors.required || formControls.interval.errors.min) {
                <span translate>Interval required</span>
              }
            </div>
          }
        </div>

      </div>

      <div class="col-12 col-lg-6">

        <!--INTERVAL TYPE-->
        <div class="form-group">
          <label for="intervalType" translate>Add interval type</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <ng-select (focusout)="onFocusOut()"
            [disabled]="!isAdminOrHigher"
            [items]="intervalTypes" [ngClass]="{ 'is-invalid': submitted && formControls.intervalType.errors }" bindLabel="value"
            bindValue="key"
            formControlName="intervalType" id="intervalType" placeholder="Select interval type">

          </ng-select>
          <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && formControls.intervalType.errors }"
            class="form-control"
            id="selectedIntervalType" type="text">
            @if (submitted && formControls.intervalType.errors) {
              <div class="invalid-feedback">
                <span translate>Interval type required</span>
              </div>
            }
          </div>

        </div>

      </div>

      <!--STARTTIME-->
      <scitis-date-time-picker
        [textLabel]="startTime"
        [showRequiredFieldIndicator]="true"
        [isDisabled]="!isAdminOrHigher"
        [showRequiredMessage]="true"
        [datePickerErrorMessage]="startDateRequired"
        [timePickerErrorMessage]="startTimeRequired"
        [submitted]="submitted"
        [startDate]="getStartDate(triggerConfiguration.effectiveStartDate)"
        [startTime]="getStartTimeFromUnixDate(triggerConfiguration.effectiveStartDate)"
        [setValidators]="true"
        [isDateValid]="isDateValid"
        [showSeconds]="true"
        (focusOut)="onFocusOutDateTime($event)">
      </scitis-date-time-picker>

    </div>
